module.exports = __webpack_public_path__ + "VIPM2.png?ed52ef2f40965dd19fa9aaad00ba9456";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/motorracing/VIPM2.png
// module id = 147
// module chunks = 0